import { baseApi } from '@/api/baseApi';

import type {
  CreateCustomProjectRequest,
  CreateCustomProjectResponse,
  GeoCity,
  ListCustomProjectsRequest,
  ListCustomProjectsResponse,
} from './types';

const CUSTOM_PROJECTS = '/lead/v1/custom-projects';

function extractData<T>(response: unknown, fallback: T): T {
  if (
    typeof response === 'object' &&
    response !== null &&
    'data' in response &&
    (response as { data?: T }).data !== undefined
  ) {
    return (response as { data: T }).data;
  }

  return (response as T | undefined) ?? fallback;
}

const customProjectsApi = baseApi.injectEndpoints({
  endpoints: build => ({
    createCustomProject: build.mutation<CreateCustomProjectResponse, CreateCustomProjectRequest>({
      query: body => ({
        url: `${CUSTOM_PROJECTS}/create`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CustomProject'],
    }),

    listCustomProjects: build.query<ListCustomProjectsResponse, ListCustomProjectsRequest>({
      query: ({ page, limit, search }) => ({
        url: `${CUSTOM_PROJECTS}/list`,
        params: { page, limit, ...(search ? { search } : {}) },
      }),
      transformResponse: response =>
        extractData<ListCustomProjectsResponse>(response, { projects: [], count: 0 }),
      providesTags: ['CustomProject'],
    }),

    getGeoCities: build.query<GeoCity[], void>({
      query: () => ({
        url: '/ps/v1/wb/geo/cities',
      }),
      transformResponse: response => extractData<GeoCity[]>(response, []),
    }),
  }),
});

export const { useCreateCustomProjectMutation, useListCustomProjectsQuery, useGetGeoCitiesQuery } =
  customProjectsApi;
